<template>
  <div
    class="conversation-details-wrap"
    :class="{ 'with-border-right': !isOnExpandedLayout }"
  >
    <woot-tabs
      v-if="dashboardApps.length && currentChat.id"
      :index="activeIndex"
      class="dashboard-app--tabs"
      @change="onDashboardAppTabChange"
    >
      <woot-tabs-item
        v-for="tab in dashboardAppTabs"
        :key="tab.key"
        :name="tab.name"
        :show-badge="false"
      />
    </woot-tabs>
    <div v-show="!activeIndex" class="messages-and-sidebar">
      <div class="messages-column">
        <conversation-header
          v-if="currentChat.id"
          :chat="currentChat"
          :is-contact-panel-open="isContactPanelOpen"
          :show-back-button="isOnExpandedLayout"
          @contact-panel-toggle="onToggleContactPanel"
        />
        <messages-view
          v-if="currentChat.id"
          :inbox-id="inboxId"
          :is-contact-panel-open="isContactPanelOpen"
          @contact-panel-toggle="onToggleContactPanel"
        />
        <empty-state v-else :is-on-expanded-layout="isOnExpandedLayout" />
      </div>
      <div v-show="showContactPanel" class="conversation-sidebar-wrap">
        <contact-panel
          v-if="showContactPanel"
          :conversation-id="currentChat.id"
          :inbox-id="currentChat.inbox_id"
          :on-toggle="onToggleContactPanel"
        />
      </div>
    </div>
    <dashboard-app-frame
      v-for="(dashboardApp, index) in visibleDashboardApps"
      v-show="activeIndex - 1 === index"
      :key="currentChat.id + '-' + dashboardApp.id"
      :is-visible="activeIndex - 1 === index"
      :config="dashboardApp.content"
      :current-chat="currentChat"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel';
import ConversationHeader from './ConversationHeader';
import DashboardAppFrame from '../DashboardApp/Frame.vue';
import EmptyState from './EmptyState';
import MessagesView from './MessagesView';

export default {
  components: {
    ContactPanel,
    ConversationHeader,
    DashboardAppFrame,
    EmptyState,
    MessagesView,
  },

  props: {
    inboxId: {
      type: [Number, String],
      default: '',
      required: false,
    },
    isContactPanelOpen: {
      type: Boolean,
      default: true,
    },
    isOnExpandedLayout: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { activeIndex: 0 };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      dashboardApps: 'dashboardApps/getRecords',
    }),
    visibleDashboardApps() {
      return this.dashboardApps.filter(dashboardApp => {
        if (Array.isArray(dashboardApp.content)) {
          return !dashboardApp.content.some(item => item.type === 'frameFull');
        }
        return dashboardApp.content?.type !== 'frameFull';
      });
    },
    dashboardAppTabs() {
      return [
        {
          key: 'messages',
          name: this.$t('CONVERSATION.DASHBOARD_APP_TAB_MESSAGES'),
        },
        ...this.visibleDashboardApps.map(dashboardApp => ({
          key: `dashboard-${dashboardApp.id}`,
          name: dashboardApp.title,
        })),
      ];
    },
    showContactPanel() {
      return this.isContactPanelOpen && this.currentChat.id;
    },
  },
  watch: {
    'currentChat.inbox_id'(inboxId) {
      if (inboxId) {
        this.$store.dispatch('inboxAssignableAgents/fetch', [inboxId]);
      }
    },
    'currentChat.id'() {
      this.fetchLabels();
      this.activeIndex = 0;
    },
  },
  mounted() {
    this.fetchLabels();
    this.$store.dispatch('dashboardApps/get');
  },
  methods: {
    fetchLabels() {
      if (!this.currentChat.id) {
        return;
      }
      this.$store.dispatch('conversationLabels/get', this.currentChat.id);
    },
    onToggleContactPanel() {
      this.$emit('contact-panel-toggle');
    },
    onDashboardAppTabChange(index) {
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~dashboard/assets/scss/woot';

.conversation-details-wrap {
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  background: var(--color-background-light);

  &.with-border-right {
    border-right: 1px solid var(--color-border);
  }
}

.dashboard-app--tabs {
  background: var(--color-surface);
  margin-top: -1px;
  min-height: var(--dashboard-app-tabs-height);
}

.messages-and-sidebar {
  display: flex;
  justify-content: center;
  background: var(--color-background-light);
  margin: 0;
  height: 100%;
  min-height: 0;
  position: relative;
}

// Coluna de mensagens (header + thread) — o header não avança sobre o painel
.messages-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.conversation-sidebar-wrap {
  border-right: 1px solid var(--color-border);
  height: auto;
  flex: 0 0 auto;
  z-index: var(--z-index-low);
  overflow: auto;
  background: var(--color-surface);
  flex-basis: 100%;

  // Largura fixa igual ao protótipo (340px)
  @include breakpoint(medium up) {
    flex-basis: 340px;
  }

  &::v-deep .contact--panel {
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
}
</style>
